import { useState } from 'react';
import { promptAppInstall } from '../lib/pwaInstall';
import {
  DESKTOP_ICON_FALLBACK,
  DESKTOP_ICON_INSTALL_BUTTON,
  DESKTOP_ICON_MODAL_BODY,
  DESKTOP_ICON_MODAL_TITLE,
} from '../lib/desktopAppIcon';
import DesktopComputerIcon from './DesktopComputerIcon';
import './DesktopAppIconModal.css';

interface DesktopAppIconModalProps {
  titleId: string;
  onClose: () => void;
}

export default function DesktopAppIconModal({ titleId, onClose }: DesktopAppIconModalProps) {
  const [status, setStatus] = useState('');
  const [installing, setInstalling] = useState(false);

  const handleInstall = async () => {
    setInstalling(true);
    setStatus('');
    try {
      const outcome = await promptAppInstall();
      if (outcome === 'accepted') {
        onClose();
        return;
      }
      if (outcome === 'dismissed') {
        setStatus('Install was cancelled. Try again, or use the browser steps below on this computer.');
        return;
      }
      setStatus(DESKTOP_ICON_FALLBACK);
    } finally {
      setInstalling(false);
    }
  };

  return (
    <div
      className="desktop-app-icon-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onClose}
    >
      <div
        className="desktop-app-icon-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="desktop-app-icon-visual" aria-hidden="true">
          <DesktopComputerIcon className="desktop-app-icon-monitor" />
        </div>
        <h2 id={titleId} className="section-header">
          {DESKTOP_ICON_MODAL_TITLE}
        </h2>
        <p className="desktop-app-icon-body scannable-bullet-text">
          {DESKTOP_ICON_MODAL_BODY}
        </p>
        <p className="desktop-app-icon-fallback scannable-bullet-text">
          {DESKTOP_ICON_FALLBACK}
        </p>
        {status && (
          <p className="desktop-app-icon-status scannable-bullet-text" role="status">
            {status}
          </p>
        )}
        <div className="desktop-app-icon-actions">
          <button
            type="button"
            className="btn-primary"
            onClick={handleInstall}
            disabled={installing}
          >
            {installing ? 'Opening install…' : DESKTOP_ICON_INSTALL_BUTTON}
          </button>
          <button type="button" className="btn-primary desktop-app-icon-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
